module.exports = "/layout/app/images/bg-section-subscribe-newsletter-before.ff824d89.svg";